import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as groupsApi from '../../../services/api/groupApi';

class GroupListItem extends React.Component {
  static propTypes = {
    key: PropTypes.number,
    group: PropTypes.object,
    selectGroup: PropTypes.func,
    everyoneIcon: PropTypes.string,
    everyoneIconBg: PropTypes.string,
    currentSelection: PropTypes.object
  };

  isEveryoneGroup = group => group.id === 0;

  renderGroupContent(isEveryone, isSelectedGroup) {
    const { group, everyoneIcon, everyoneIconBg } = this.props;

    if (isEveryone) {
      const everyoneImage = isSelectedGroup ? everyoneIcon : everyoneIconBg;
      return <img src={everyoneImage} alt="presentation" />;
    }

    return <span>{groupsApi.getGroupFirstChar(group)}</span>;
  }

  selectGroup = () => {
    const { selectGroup, group } = this.props;
    selectGroup(group.id);
  };

  render() {
    const { group, currentSelection } = this.props;
    const isEveryone = this.isEveryoneGroup(group);
    const isSelectedGroup = currentSelection && currentSelection.isGroup && group.id === currentSelection.id;
    const groupClassName = isEveryone ? 'group-item-everyone' : `group-item-${group.colour}`;

    return (
      <div className="students-group-component">
        <div
          className={`students-group-circle ${isSelectedGroup ? groupClassName : ''}`}
          onClick={() => this.selectGroup(group)}
        >
          {this.renderGroupContent(isEveryone, isSelectedGroup)}
        </div>

        <div
          className={`students-group-title ${isSelectedGroup ? groupClassName : ''}`}
          onClick={this.selectGroup.bind(this, group)}
        >
          {groupsApi.getGroupName(group)}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    everyoneIcon: state.theme.images.icons.groupColor,
    everyoneIconBg: state.theme.images.icons.groupBg
  };
}

export default connect(mapStateToProps)(GroupListItem);
